import { Avatar, Chip } from "@material-ui/core";
import { useLiveQuery } from "dexie-react-hooks";
import { CustomerTypeRepository } from "../../utils/dexie/repositories/customer-type-repository";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FontAwesomeDuoToneStyle } from "../../fontawesome";

export const CustomerType = ({
    customerTypeId
}) => {
    const customerType = useLiveQuery(async () => customerTypeId != null ? await CustomerTypeRepository.get(customerTypeId) : null, [customerTypeId]);

    if (customerType == null)
        return null;

    return (
        <Chip size="small" color="primary" 
            label={customerType.translatedTerm} 
            avatar={
                <Avatar style={{backgroundColor: customerType?.foregroundColor ?? '#FFF'}}>
                    <FontAwesomeIcon icon={["fad", "user-tag"]} size="xl" style={FontAwesomeDuoToneStyle} />
                </Avatar>
            }
            style={{
                color: customerType.foregroundColor,
                backgroundColor: customerType.backgroundColor
            }} 
        />
    );

}